import * as _ from 'lodash';
import { Component, inject, OnInit } from '@angular/core';

import { _BaseRouteComponent } from './_base-route-component';
import { SinglePageService } from 'src/app/features/shared/central-page/services/single-page.service';
import { pageTransitionAnimation } from '../../animations/route-animations';
import { showAnimation } from '../../animations/show-animation';
import { pageMode, TPageMode } from '../../models/page-mode';
import { ILevelGeneralDto } from '../../models/level-general-dto';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Component({
    selector: 'app-single-page-rout-component',
    template: '',
    styles: [],
    animations: [
        pageTransitionAnimation,
        showAnimation,
    ],
})
export abstract class _SinglePageRouteComponent<DtoModel extends ILevelGeneralDto | null, FormModel>
    extends _BaseRouteComponent
    implements OnInit
{
    protected readonly _singlePageService = injectRequired(SinglePageService);

    pageMode_initial: TPageMode = pageMode.detailsPage;
}
